/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import { noShadowDOM } from 'component-register';
import CustomSelect, { type CustomSelectProps } from './CustomSelect';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-custom-select': Partial<HTMLElement> &
        CustomSelectProps &
        Partial<{ ref: any }>;
    }
  }
}

export function defineSolidCustomSelect(): void {
  customElement(
    'tc-custom-select',
    {
      // Include ALL props with default values
      name: undefined as unknown as string,
      label: undefined as unknown as string,
      options: [] as unknown[] as CustomSelectProps['options'],
      getValue: undefined as unknown as CustomSelectProps['getValue'],
      getDisplayValue:
        undefined as unknown as CustomSelectProps['getDisplayValue'],
      defaultValue: undefined as unknown as string | number | undefined,
      value: undefined as unknown as string | number | undefined,
      onChange: undefined as unknown as CustomSelectProps['onChange'],
      errorMsg: undefined as unknown as string | undefined,
      disabled: false,
      id: undefined as unknown as string | undefined,
      'data-cy': undefined as unknown as string | undefined,
      dataCy: undefined as unknown as string | undefined,
      renderMode: undefined as unknown as CustomSelectProps['renderMode'],
      indeterminate: false,
      indeterminateLabel: undefined as unknown as string | undefined,
      hideLabel: false,
      triggerClassName: undefined as unknown as string | undefined,
      linkClassName: undefined as unknown as string | undefined,
      arrowIconClassName: undefined as unknown as string | undefined,
      menuClassName: undefined as unknown as string | undefined,
      usePortal: false,
      onSelect: undefined as unknown as CustomSelectProps['onSelect'],
    },
    (props) => {
      noShadowDOM();
      return <CustomSelect {...props} />;
    }
  );
}

export type { CustomSelectProps };
